import React from "react"
import Layout from "../components/layout/layout"
import styled from "styled-components"
import media from "styled-media-query"

const Privacy = () => {
  return (
    <Layout>
      <Container>
        <h1>Our Privacy Policy</h1>

        <h2>
          It couldn’t be easier. We strongly support your right to privacy when
          using our apps.
        </h2>
        <Seporator />
        <p1>
          <b>
            Our privacy policy is simple: your data is none of our business.
          </b>
          Show StopWatch doesn’t collect any personal information, the
          information that you enter - say saving email addresses to make
          sharing your show times easier, is all kept on your device. The only
          information we can see is that which Apple anonymously shares with
          developers after the user has opted in - for example how many
          downloads or what type of device you are running Show StopWatch on,
          more information can be found{" "}
          <a href="https://www.apple.com/uk/privacy/manage-your-privacy/">
            here
          </a>
          .
        </p1>
        <Seporator />
        <p2>
          Your privacy is important to us. It is Show StopWatcs&apos;s policy to
          respect your privacy regarding any information we may collect from you
          across our website and other sites and apps we own and operate.
        </p2>
        <p2>
          We only ask for personal information when we truly need it to provide
          a service to you. We collect it by fair and lawful means, with your
          knowledge and consent. We also let you know why we’re collecting it
          and how it will be used.
        </p2>
        <p2>
          We only retain collected information for as long as necessary to
          provide you with your requested service. What data we store, we’ll
          protect within commercially acceptable means to prevent loss and
          theft, as well as unauthorised access, disclosure, copying, use or
          modification.
        </p2>
        <p2>
          We don’t share any personally identifying information publicly or with
          third-parties, except when required to by law.
        </p2>
        <p2>
          Our website may link to external sites that are not operated by us.
          Please be aware that we have no control over the content and practices
          of these sites, and cannot accept responsibility or liability for
          their respective privacy policies.
        </p2>
        <p2>
          You are free to refuse our request for your personal information, with
          the understanding that we may be unable to provide you with some of
          your desired services.
        </p2>
        <p2>
          Your continued use of our website will be regarded as acceptance of
          our practices around privacy and personal information. If you have any
          questions about how we handle user data and personal information, feel
          free to contact us.
        </p2>
        <p2>This policy is effective as of 31 January 2020.</p2>
      </Container>
    </Layout>
  )
}

export default Privacy

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 8em;
  margin-right: 8em;
  a {
    color: white;
    font-style: italic;
  }
  b {
    font-weight: 600;
  }
  h1 {
    color: white;
    text-align: center;
    padding-top: 1em;
    padding-bottom: 1em;
  }
  h2 {
    color: white;
    text-align: center;
    font-weight: 500;
  }
  p1 {
    color: white;
    font-weight: 300;
    margin-top: 2em;
  }

  p2 {
    color: #c0c0c0;
    font-weight: 250;
    margin-top: 0.7em;
  }

  ${media.lessThan("medium")`
  margin-left: 2em;
margin-right:2em;
  `}
`
const Seporator = styled.div`
  display: flex;
  background-color: #505050;
  height: 1.5px;
  margin: 2em;
  margin-left: auto;
  margin-right: auto;
  float: center;
  width: 60%;
`
